import { createSlice } from '@reduxjs/toolkit';

export const domainSlice = createSlice({
  name: 'domain',
  initialState: {
    domain: null,
  },
  reducers: {
    setDomain: (state, action) => {
      state.domain = action.payload;
    },
  },
});

export const { setDomain } = domainSlice.actions;

export default domainSlice.reducer;
